import React, { useState } from "react";
import { InputController } from "./InputController";
import { Button, Input, Stack } from "@mui/material";
import { Upload } from "@mui/icons-material";
import { UploadController } from "./UploadController";
import axios from "axios";

const Step3 = (props) => {
  // const onChange = async(e)=>{
  //   const fieldName = e.target.name
  //   const files = e.target.files;
  //   const formData = new FormData();
  //   for(let i=0; i<files.length; i++)
  //   {
  //     formData.append(`${fieldName}`,files[i])
  //   }
  //   await axios.post("http://localhost:3000/api/v1/images",formData, { 
  //     headers:{"Content-Type": "multipart/form-data"} 
  //   });
  // }
  return (
    <Stack
      direction="column"
      alignItems="center"
      spacing={4}
      sx={{
        width: "450px",
        margin: "auto",
        marginTop: "40px",
        marginBottom: "10px",
      }}
    >
      {/* <input  type="file" name="logo" onChange={onChange}/>
      <input type="file" name="images" multiple/> */}
      {/* <Button variant="outlined" startIcon={<Upload />}>
        Business Logo
      </Button> */}
      <UploadController 
        name="logo" 
        label="Business Logo" 
        variant="outlined" 
        accept=".jpg, .jpeg, .png"
      />
      <UploadController
        name="images"
        label="Business Images"
        variant="outlined"
        accept=".jpg, .jpeg, .png"
        multiple
      />
    </Stack>
  );
};

export { Step3 };
